import React, { Fragment, useRef, useState, useEffect } from 'react'
import { gql, useQuery } from '@apollo/client'
import Card from '../common/Card'
import { CubeLoader } from '../../layouts/components/CubeLoader'
import Tooltip from '../common/Tooltip'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/flatpickr.css'
import { CalendarIcon } from '../icons'

const GET_SUMMARY = gql`
    query Campaigns {
        campaigns {
            name
            summary
            lastSummarisedAt
        }
    }
`

const SummarisationReport = () => {
    const campaign = useQuery(GET_SUMMARY)
    const fp = useRef(null)
    const [selectedDate, setSelectedDate] = useState(null)
    const [tmDates, setTmDates] = useState([])

    const date = () => {
        const sums = summaries()
        try {
            let date = sums.find((item) => item.date === selectedDate)['date']
            const dateParts = date.split('/')
            date = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`)
            return new Intl.DateTimeFormat('en-AU', { day: '2-digit', month: 'short', year: 'numeric' }).format(date)
        } catch (error) {
            const date = campaign.data.campaigns[0].lastSummarisedAt
            return campaign.data.campaigns[0]?.lastSummarisedAt
                ? new Intl.DateTimeFormat('en-AU', { day: '2-digit', month: 'short', year: 'numeric' }).format(
                      new Date(date),
                  )
                : null
        }
    }

    const summaries = () => {
        try {
            return campaign.data.campaigns[0]?.summary ? JSON.parse(campaign.data.campaigns[0]?.summary) : null
        } catch (error) {
            return campaign.data.campaigns[0]?.summary
        }
    }

    const text = () => {
        const sums = summaries()
        try {
            return sums.find((item) => item.date === selectedDate)['text']
        } catch (error) {
            return typeof sums === 'string' ? sums : ''
        }
    }

    const handleDateChange = (selectedDates, dateStr, instance) => {
        const dateParts = dateStr.split('-')
        const formattedDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`
        setSelectedDate(formattedDate)
    }

    useEffect(() => {
        if (tmDates.length === 0) {
            let date, dates
            try {
                date = campaign.data.campaigns[0]?.summary
                    ? JSON.parse(campaign.data.campaigns[0]?.summary).pop()['date']
                    : null
                dates = campaign.data.campaigns[0]?.summary
                    ? JSON.parse(campaign.data.campaigns[0]?.summary).map((item) => item.date)
                    : []
            } catch (error) {
                date = null
                dates = []
            }

            if (date) {
                setSelectedDate(date)
            }

            if (dates) {
                dates = dates.map((item) => {
                    const dateParts = item.split('/')
                    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
                })

                setTmDates(dates)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- tmDates is derived state; we only want to run when campaign/selectedDate change
    }, [campaign, selectedDate])

    return (
        <Card>
            {campaign.loading ? (
                <CubeLoader size="sm" fullScreen={false} />
            ) : (
                <Fragment>
                    <Card.Header className="card-header p-4 flex-column pb-1">
                        <div className="d-flex justify-content-between align-items-center gap-2">
                            <h6 className="card-title">Time Machine</h6>
                            {date() && (
                                <div className="d-flex align-items-center gap-1">
                                    <button
                                        type="button"
                                        className="border-0 bg-transparent p-0 d-flex align-items-center text-blue-300"
                                        onClick={() => fp.current?.flatpickr?.open()}
                                        aria-label="Open date picker"
                                    >
                                        <CalendarIcon size={20} />
                                    </button>
                                    <Flatpickr
                                        ref={fp}
                                        options={{ enable: tmDates }}
                                        className="hidden-input"
                                        onChange={handleDateChange}
                                    />
                                    <span className="text-blue-300">{date()}</span>
                                    <Tooltip
                                        text={
                                            'Click on the Calendar icon to select different date to see other Summaries'
                                        }
                                    />
                                </div>
                            )}
                        </div>
                    </Card.Header>
                    <Card.Body className="card-thumbnail p-4 pt-1">
                        <h6 className="card-title mb-2 small">Generative AI Summarisation</h6>
                        {date() ? <p className="small mb-0">{text()}</p> : <p className="small mb-0">In Progress...</p>}
                    </Card.Body>
                </Fragment>
            )}
        </Card>
    )
}

export default SummarisationReport
